import { TFunction } from "i18next";
import { InstanceStatus } from "../types";

export const InstanceStatusColorAndMeanings = (
  t: TFunction<"ns1", undefined>,
) => [
  {
    type: InstanceStatus.completed,
    color: "green",
    name: t("food.Completed"),
  },
  {
    type: InstanceStatus.completedWithErrors,
    color: "orange",
    name: t("food.Completed With Error"),
  },
  {
    type: InstanceStatus.overdueSubmitted,
    color: "red",
    name: t("food.Overdue Submitted"),
  },
];
